import PeriodicTableApp from './app.js';

if (self.cordova) {
    document.addEventListener('deviceready', () => {
        self.APP = new PeriodicTableApp(document.getElementById('app'));
    }, false);
} else {
    self.APP = new PeriodicTableApp(document.getElementById('app'));
}
